import React, {useCallback, useEffect, useMemo, useState} from 'react';
import '../styles/common.css';
import '../styles/balloon.css';
import Footer from "../components/Footer";
import WhatIsSekigahara from "../components/WhatIsSekigahara";
import {firestore} from "../common/firebase";
import person from "../resources/person-black-18dp.svg";
import * as firebase from "firebase";
import Pie from "../components/Pie";
import * as d3 from "d3";

const Kind = {
    SEIGUN: 0,
    TOUGUN: 1,
};

function Home() {
    const [status, setStatus] = useState({
        isKomei: false,
        isSeigun: true,
        isSending: false,
        hasSend: false,
        comment: "",
        error: "",
        tougunMessages: [],
        seigunMessages: [],
        pieChartData: [{
            date: 0,
            name: "東軍",
            value: 0,
        }, {
            date: 1,
            name: "西軍",
            value: 0,
        }],
        hasAuthenticated: false,
    });
    const getMessage = useCallback((kind, name, text) => {
        return {
            name: name,
            text: text
        };
    }, []);
    const toggleAsUser = useCallback(() => {
        const newIsKomei = !status.isKomei;
        let isSeigun = status.isSeigun;

        if (newIsKomei) {
            isSeigun = false;
        }
        setStatus({
            ...status,
            isKomei: !status.isKomei,
            isSeigun: isSeigun
        });
    },[status]);
    const toggleIsSeigun = useCallback(() => {
        if (status.isKomei) {
            return;
        }
        setStatus({
            ...status,
            isSeigun: !status.isSeigun
        });
    },[status]);
    const onCommentChange = useCallback((event) => {
        setStatus({
            ...status,
            comment: event.target.value
        })
    }, [status]);
    const doSend = useCallback(() => {
        const messageRefs = firestore.collection('messages');
        // メッセージをfirestoreへ送信
        messageRefs.add({
            kind: (status.isSeigun)? Kind.SEIGUN : Kind.TOUGUN,
            name: (status.isKomei)? "諸葛孔明": "一般人",
            text: status.comment,
            timestamp: new Date()
        }).then(()=>{
            setStatus({
                ...status,
                isSending: false,
                hasSend: true,
                comment: ""
            });
        });
        
    }, [status]);
    const onSend = useCallback(() => {
        if (!status.comment) {
            setStatus({
                ...status,
                error: "コメントを入力してください。",
                hasSend: false,
            });
        } else {
            setStatus({
                ...status,
                error: "",
                isSending: true,
                hasSend: false,
            });
        }
        
        if (!status.hasAuthenticated) {
            // ここでFirebaseと非同期で通信しユーザーIDを発行している
            firebase.auth().signInAnonymously().catch( (error) => {
                console.log(`[error] Can not signin anonymouse (${error.code}:${error.message})`);
            });

            // 認証状態が変化すると呼び出される
            firebase.auth().onAuthStateChanged( (user) => {
                if ( user ) {
                    setStatus({
                        ...status,
                        hasAuthenticated: true
                    });
                    doSend();
                }
            });
        } else {
            doSend();
        }
    }, [doSend, status.comment, status.error, status.hasAuthenticated]);
    useEffect(() => {
        const query = firestore
            .collection('messages')
            .orderBy('timestamp', 'asc')
            .limit(100);

        query.onSnapshot(function(snapshot) {
            const tMsg = status.tougunMessages;
            const sMsg = status.seigunMessages;
            const newPiechartData = status.pieChartData;
            snapshot.docChanges().forEach((change) => {
                if (change.type === 'added') {
                    const message = change.doc.data();
                    if (message.kind === Kind.TOUGUN) {
                        tMsg.push(getMessage(message.kind, message.name, message.text));
                        newPiechartData[0].value += 1;
                    } else {
                        sMsg.push(getMessage(message.kind, message.name, message.text));
                        newPiechartData[1].value += 1;
                    }
                }
            });
            setStatus({
                ...status,
                tougunMessages: tMsg,
                seigunMessages: sMsg,
                pieChartData: newPiechartData
            });
        });
    // 初回のいちどだけ呼ばれるため、除外する
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[]);
    
    const sendMessage = useMemo(() => {
        const messages = [];

        if (status.isKomei) {
            messages.push("諸葛孔明として");
        } else {
            messages.push("一般人として");
        }
        if (status.isSeigun) {
            messages.push("西軍が勝つという予想を");
        } else {
            messages.push("東軍が勝つという予想を");
        }
        return (
            <p>{messages}送信する</p>
        );

    }, [status.isKomei, status.isSeigun]);

    return (
        <React.Fragment>
            <div className="container">
                <p>Stylish Discussion Battle</p>
                <h1>関ヶ原</h1>
                <p>Stylish Discussion Battle「関ヶ原」とは、<br/>
                関ヶ原の戦いの勝敗をみんなで議論するWebアプリケーションです。</p>
                <p className="eye-catch">東軍と西軍、あなたはどちらが勝つと思いますか？</p>
                <WhatIsSekigahara/>
            </div>
            <div className="container after-hint">
                <div className="row">
                    <div className="column">
                        <div className="tweet-box">
                            <div className="seigun-header">
                                西軍が勝つ！
                            </div>
                            {status.seigunMessages.map((e, index ) => {
                                return (<div className="tweet-div" key={index}>
                                    <div className="container">
                                        <div className="row">
                                            <div className="column column-10 person-div">
                                                <img alt="logo" className="person-img" src={person}/>
                                            </div>
                                            <div className="column">
                                                <div className="tweet-header">
                                                    <p className="name">{e.name}</p>
                                                </div>
                                                <div className="tweet-body">
                                                    {e.text}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>)
                            })}
                        </div>
                    </div>
                    <div className="column">
                        <div className="tweet-box">
                            <div className="tougun-header">
                                東軍が勝つ！
                            </div>
                            {status.tougunMessages.map((e, index ) => {
                                return (<div className="tweet-div" key={index}>
                                    <div className="container">
                                        <div className="row">
                                            <div className="column column-10 person-div">
                                                <img alt="logo" className="person-img" src={person}/>
                                            </div>
                                            <div className="column">
                                                <div className="tweet-header">
                                                    <p className="name">{e.name}</p>
                                                </div>
                                                <div className="tweet-body">
                                                    {e.text}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>)
                            })}
                        </div>
                    </div>
                </div>
                <div className="row">
                    <hr/>
                </div>
                <div className="row">
                    <div className="column predict-button">
                        <h3>
                            勝敗を予想する
                        </h3>
                    </div>
                </div>
                <div className="row">
                    <div className="column predict-button">
                        <p>あなたは誰ですか？</p>
                        <button className={"control-button " + ((!status.isKomei)? "selected" : "not-selected")} onClick={toggleAsUser}>
                            一般人
                        </button>
                        <button className={"control-button " + ((status.isKomei)? "selected" : "not-selected")} onClick={toggleAsUser}>
                            諸葛孔明
                        </button>
                    </div>
                </div>
                <div className="row">
                    <div className="column predict-button">
                        <p>どっちが勝つと思いますか？</p>
                        {(!status.isKomei && (
                            <button className={"control-button " + ((status.isSeigun)? "selected" : "not-selected")} onClick={toggleIsSeigun}>
                                西軍
                            </button>
                        ))}

                        <button className={"control-button " + ((!status.isSeigun)? "selected" : "not-selected")} onClick={toggleIsSeigun}>
                            東軍
                        </button>
                    </div>
                </div>
                <div className="row">
                    <div className="column predict-button">
                        <label htmlFor="nameField">コメントをどうぞ</label>
                        <input type="text" placeholder="" id="nameField" value={status.comment}
                        onChange={onCommentChange}/>
                    </div>
                </div>
                <div className="row">
                    <div className="column predict-button">
                        <button className="control-button" onClick={onSend}>
                            {sendMessage}
                        </button>
                        {(status.error) && (
                            <p className="error">status.error</p>
                        )}
                        {(status.isSending) && (
                            <p className="error">送信中...</p>
                        )}
                        {(status.hasSend) && (
                            <p className="error">送信中しました！</p>
                        )}
                    </div>
                </div>
            </div>
            <div className="pie">
                <p className="label">投票状況</p>
                <Pie
                    data={status.pieChartData}
                    width={200}
                    height={200}
                    innerRadius={60}
                    outerRadius={100}
                />
            </div>
            <Footer seigunMessages={status.seigunMessages} tougunMessages={status.tougunMessages}/>
        </React.Fragment>
    );
}

export default Home;